import React, { Component } from 'react'
import { SearchField } from './HelperComponents/SearchField';


export default class Test extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    getLookupState = (item) => {

    }
    refreshList = () => {

    }
    render() {
        return (
            <div>
              <SearchField />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Test.jsx